import React from "react";
import { Outlet } from "react-router-dom";
import { useWorkspaceContext } from "../../../providers/WorkspaceProvider";
import { FloatingChatWidget } from "../components/MyVaultAgent";

/** Keep the Views assistant mounted while navigating between views pages. */
export default function MyVaultViewsLayout() {
  const { workspace } = useWorkspaceContext();

  return (
    <>
      <Outlet />
      {workspace?.id && <FloatingChatWidget workspaceId={workspace.id} />}
    </>
  );
}
